import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { __, hasFreeTrialDashboard, isCommerceInactive } from "@jti/fe-common";
import { useConfig } from "../../providers/useConfig";
import { LinkElement } from "./LinkElement";
import styles from "./NavBar.module.scss";
const getLinks = (hasLoyalty = false, config) => {
    const profilePageUrl = config.PROFILE_PAGE_URL || "/profile.html";
    // TODO: replace depreated translation functions
    return [
        {
            name: "dashboard",
            to: "/",
            external: profilePageUrl,
            text: __("com.nav_bar.dashboard.title"),
            dataTestId: "accountDashboard",
        },
        {
            name: "orders",
            to: "/orders",
            external: profilePageUrl,
            text: __("com.nav_bar.orders.title"),
            inactive: isCommerceInactive(),
            dataTestId: "myOrders",
        },
        {
            name: "subscription",
            to: "/subscription",
            external: profilePageUrl,
            text: __("com.nav_bar.subscription.title"),
            inactive: !config.enableSubscriptions,
            dataTestId: "mySubscription",
        },
        {
            inactive: !hasFreeTrialDashboard(),
            name: "trials",
            to: "/free-trial",
            external: profilePageUrl,
            text: __("com.nav_bar.orders.free.title"),
            dataTestId: "myTrialOrders",
        },
        {
            name: "loyalty",
            external: config.LOYALTY_PROFILE_PAGE_URL || "/loyalty/account.html",
            text: __("com.nav_bar.orders.ploomClub"),
            dataTestId: "ploom-club",
            inactive: !hasLoyalty,
            alwaysExternal: true,
        },
        {
            name: "account",
            to: "/account",
            external: profilePageUrl,
            text: __("com.nav_bar.account.title"),
            dataTestId: "accountinfo",
        },
        {
            name: "address",
            external: profilePageUrl,
            to: "/address",
            text: __("com.nav_bar.address.title"),
            dataTestId: "myAdresses",
        },
        {
            name: "devices",
            to: "/devices",
            external: profilePageUrl,
            text: __("com.nav_bar.devices.title"),
            dataTestId: "myDevices",
        },
        {
            name: "communication",
            to: "/communication",
            external: profilePageUrl,
            text: __("com.nav_bar.communication.title"),
            dataTestId: "communicationPreferences",
        },
    ].filter((a) => !a.inactive);
};
export const NavBar = ({ hasLoyalty = false, isExternal = false, onClick }) => {
    const config = useConfig();
    const links = useMemo(() => getLinks(hasLoyalty, config), [hasLoyalty, config]);
    return (_jsx("nav", { className: styles.container, children: _jsx("ul", { className: styles.list, "data-testid": "accountDashboardBlock", children: links.map((link) => {
                if (!link.text || link.text.length === 0) {
                    return null;
                }
                return (_jsx("li", { "data-testid": link.dataTestId, ...(onClick && { onClick: () => onClick(link) }), children: _jsx(LinkElement, { link: link, isExternal: isExternal, alwaysExternal: !!link.alwaysExternal }) }, link.name));
            }) }) }));
};
//# sourceMappingURL=NavBar.js.map